import React from 'react';
import styled, { css } from 'styled-components';
import JSEventUtils from '../utils/JSEventUtils';
import Image from './Image';
import StringFormatter from '../utils/StringFormatter';
import { LoaderSvgData } from "./LoaderImage";
import PermissionControlledComponent from "./PermissionControlledComponent";
import FeatureControlledComponent from "./FeatureControlledComponent";
export var ButtonSize;
(function (ButtonSize) {
    ButtonSize["EXTRA_SMALL"] = "EXTRA_SMALL";
    ButtonSize["SMALL"] = "SMALL";
    ButtonSize["MEDIUM"] = "MEDIUM";
    ButtonSize["LARGE"] = "LARGE";
})(ButtonSize || (ButtonSize = {}));
const Button = React.forwardRef(({ text, parameters, imgSrc, imgAlt, imgAltParameters, height, width, rightContent, isLoading, isDisabled, isHidden, requireAllDirectPermissions, requireOneDirectPermission, requireFeature, propagateClick, onClick, buttonSize = ButtonSize.MEDIUM, wrapText = true, ...rest }, ref) => {
    // TODO ADD I18N
    const outputText = StringFormatter(text, parameters);
    const handleClick = (event) => {
        if (!propagateClick && !isDisabled) {
            JSEventUtils.stopEventPropagation(event);
            onClick && onClick(event);
        }
    };
    const hasImage = isLoading || (imgSrc && imgSrc.length > 0) === true;
    // Do not return the button if it is hidden
    if (isHidden)
        return null;
    return React.createElement(FeatureControlledComponent, { requireFeature: requireFeature },
        React.createElement(PermissionControlledComponent, { requireAllDirectPermissions: requireAllDirectPermissions, requireOneDirectPermission: requireOneDirectPermission },
            React.createElement(ButtonWrapper, { onClick: handleClick, isLoading: isLoading, isDisabled: isDisabled && !isLoading, isHidden: isHidden, ref: ref, buttonSize: buttonSize, ...rest },
                React.createElement(ButtonContent, null,
                    React.createElement(ButtonImage, { isVisible: hasImage, alt: imgAlt || text, altParameters: imgAltParameters || parameters, height: height, width: width, src: isLoading ? LoaderSvgData : imgSrc }),
                    React.createElement(ButtonLabel, { addSpacing: hasImage && outputText.length > 0, wrapText: wrapText }, outputText),
                    rightContent &&
                        React.createElement(RightContentWrapper, null, rightContent)))));
});
Button.displayName = 'Button';
const RightContentWrapper = styled.div `
    display: inline-block;
    
    
    font-family: ${props => props.theme.fonts.medium};
    font-size: 14px;
`;
const ButtonWrapper = styled("span") `
    display: flex;
    
    cursor: pointer;
    
    align-items: center;
    ${props => props.buttonSize == ButtonSize.EXTRA_SMALL && ExtraSmallSizedWrapping};
    ${props => props.buttonSize == ButtonSize.SMALL && SmallSizedWrapping};
    ${props => props.buttonSize == ButtonSize.MEDIUM && MediumSizedWrapping};
    ${props => props.buttonSize == ButtonSize.LARGE && LargeSizedWrapping};
    
    text-decoration: none;
    text-align: center;
    
    ${props => props.isLoading && LoadingBehaviour}
    ${props => props.isDisabled && DisabledBehaviour}
`;
const ExtraSmallSizedWrapping = css `
    padding: 0px;
`;
const SmallSizedWrapping = css `
    padding: 2px 5px;
`;
const MediumSizedWrapping = css `
    padding: 5px 14px;
`;
const LargeSizedWrapping = css `
    padding: 5px 14px;
`;
const ButtonContent = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
`;
const ButtonImage = styled(({ height, isVisible, width, ...rest }) => React.createElement(Image, { ...rest })) `
    display: none;
    display: ${props => props.isVisible && 'inline-block'};
    
    height: 20px;
    height: ${props => `${props.height}px`};
    
    width: 20px;
    width: ${props => `${props.width}px`};
    
    margin-top: -0.5px;
`;
const ButtonLabel = styled("div") `
    display: inline-block;
    font-family: ${props => props.theme.fonts.medium};
    font-size: 14px;
    
    margin-left: 0;
    margin-left: ${props => props.addSpacing && '3px'};
    
    white-space: normal;
    white-space: ${props => !props.wrapText && 'nowrap'};
    
    padding: 1px 0;
`;
const LoadingBehaviour = css `
    cursor: default;
`;
const DisabledBehaviour = css `
    cursor: default;
    opacity: 0.5;
`;
export default Button;
//# sourceMappingURL=Button.js.map